import { IS_USER_SITE_MINES } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import React, { useCallback, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { PieChartCard } from "../ChartCard/ChartCard";
import Srcollbar from "react-perfect-scrollbar";

const PieChartWithModal = React.memo(function PieChartWithModal({
  title,
  seriesData,
  id,
  isMobile,
  pieChartColour,
  scrollLegend,
  setZoomActive,
  zoomActive,
}) {
  const [modelChart, setModelChart] = useState({});
  const [shows, setShows] = useState(false);

  const handleClose = useCallback(() => {
    setShows((prev) => !prev);
  }, []);

  const getPieElementData = useCallback(
    (e) => {
      // console.log("eeeee", e);
      setModelChart(e?.data?.modalCharts || []);
      handleClose();
    },
    [handleClose]
  );
  const hoSiteData = useMemo(
    () => modelChart?.charts?.find((item) => item?.hoSite),
    [modelChart?.charts]
  );

  return (
    <>
      <PieChartCard
        title={title}
        seriesData={seriesData || []}
        customLabelFalse={true}
        isCustomLegend={true}
        id={id}
        isMobile={isMobile}
        {...(!IS_USER_SITE_MINES()
          ? { dataFromChartCard: getPieElementData, isClick: true }
          : {})}
        pieChartColour={pieChartColour}
        scrollLegend={scrollLegend}
        setZoomActive={setZoomActive}
        zoomActive={zoomActive}
      />

      <Modal size={"lg"} show={shows} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>{modelChart?.label}</Modal.Header>

        <Modal.Body style={{ overflow: "hidden" }}>
          <Srcollbar className="modalTableFixedheight">
            <div className="card" style={{ overflow: "visible" }}>
              <div className="card-body">
                <div className="row justify-content-center">
                  {/* {hoSiteData && (
                    <WidgetItem
                      colClass="col-md-3"
                      header={hoSiteData?.label}
                      value={hoSiteData?.count}
                    />
                  )} */}
                </div>
                <Row className="screenOne">
                  {modelChart?.charts?.map(
                    (item, idx) =>
                      !item?.hoSite && (
                        <Col lg={6} id={`modal_pie_chart_${idx}`} key={item?.label}>
                          <PieChartCard
                            id={`modal_pie_chart_${idx}`}
                            title={item?.label}
                            isMobile={isMobile}
                            seriesData={item.chartData}
                            dataFromChartCard={getPieElementData}
                            isClick={false}
                            customLabelFalse={true}
                            isCustomLegend={true}
                            scrollLegend={true}
                            hideZoom={true}
                          />
                        </Col>
                      )
                  )}
                </Row>
              </div>
            </div>
          </Srcollbar>
        </Modal.Body>
      </Modal>
    </>
  );
});

export default PieChartWithModal;

function WidgetItem({ header, value, iconClassName, colClass }) {
  return (
    <div className={colClass ? colClass + " pb-3" : "col-md-2  pb-3"}>
      <div className="card card-icon-bg mb-3 customWidgets ehswidgets">
        <div className="card-body text-center content d-flex justify-content-between">
          {/* <i className="i-Engineering"></i> */}
          {/* <div className="content"> */}
          <p>{header}</p>
          <h4>{value}</h4>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

export const MANAGE_PIE_CHART_WITH_LARGE_DATA = (dataLength) => {
  switch (true) {
    case dataLength > 30 && dataLength <= 70:
      return { right: 270, seriesOptions: { radius: "60%", center: ["35%", "80%"] } };
    case dataLength > 70 && dataLength <= 105:
      return { right: 150, seriesOptions: { radius: "60%", center: ["30%", "80%"] } };
    case dataLength > 105:
      return { right: 10, seriesOptions: { radius: "60%", center: ["25%", "80%"] } };
    default:
      return false; // or any other default value or behavior
  }
};
